import Description from '../../components/Description/Description'
import React from 'react'
import FooterComp from '../../components/Footer/FooterComp'

const Impact = () => {
  return (
    <div>
      <Description/>
      <FooterComp/>
    </div>
  )
}

export default Impact;